import styled, { css, createGlobalStyle } from 'styled-components'
import {
  colorWhiteSelector,
  getColorBackgroundSelector,
  getColorPrimarySelector,
  getColorTextSelector
} from '@purecarslabs/signal-theme/selectors'
import isDarkColor from '@purecarslabs/signal-utils/isDarkColor'
import { MvhColorsType } from '@app-src/types'

const cssModalStyleOverride = css<{
  $formLoaded: boolean
  $mvhColors?: MvhColorsType | null
}>`
  * {
    font-family: 'PC LeadForms Custom Font Normal', 'Source Sans', sans-serif;
  }

  .MuiDialog-root {
    z-index: 2147483647 !important;

    ${({ $mvhColors }) =>
      $mvhColors?.backgroundColor && isDarkColor($mvhColors?.backgroundColor)
        ? `
      a {  
        color: lightblue;
      }
    `
        : ''}

    form {
      margin-bottom: 8px;

      @media only screen and (max-height: 784px) {
        margin-bottom: 0px;
      }
    }

    .terms-toggle {
      font-size: 9.8px;
    }
  }

  .MuiDialogTitle-root {
    display: none;
  }

  .MuiDialog-paper {
    background: ${({ $mvhColors }) =>
      $mvhColors?.backgroundColor || getColorBackgroundSelector()};
    color: ${({ $mvhColors }) =>
      $mvhColors?.textColor || getColorTextSelector()};
    border-radius: 10px;
  }

  .modal-choice-ok:not(.Mui-disabled),
  .modal-choice-ok:not(.Mui-disabled):hover {
    display: ${({ $formLoaded }) => ($formLoaded ? 'block' : 'none')};
    background: ${({ $mvhColors }) =>
      $mvhColors?.submitButtonColor || getColorPrimarySelector()};
    color: ${({ $mvhColors }) =>
      $mvhColors?.submitButtonTextColor || colorWhiteSelector};

    span {
      font-family: 'PC LeadForms Custom Font Bold',
        'PC LeadForms Custom Font Normal', 'Source Sans', sans-serif;
    }
  }

  @media only screen and (max-height: 784px) {
    .modal-choice-ok {
      padding: 8px;
    }
  }

  .modal-choice-cancel,
  .modal-choice-cancel:hover {
    display: ${({ $formLoaded }) => ($formLoaded ? 'block' : 'none')};
    background: ${({ $mvhColors }) =>
      $mvhColors?.cancelButtonColor || getColorPrimarySelector()};
    color: ${({ $mvhColors }) =>
      $mvhColors?.cancelButtonTextColor || colorWhiteSelector};

    span {
      font-family: 'PC LeadForms Custom Font Bold',
        'PC LeadForms Custom Font Normal', 'Source Sans', sans-serif;
    }

    @media only screen and (max-height: 784px) {
      padding: 8px;
    }
  }

  @media only screen and (max-width: 480px) {
    .MuiDialog-paper {
      width: 100%;
      margin: 8px;
      padding: 8px !important;
    }

    .MuiDialogContent-root {
      padding: 8px;

      .terms-toggle {
        font-size: 9px;
      }
    }
  }

  @media only screen and (max-width: 400px) {
    .MuiDialog-paper {
      width: 100%;
      margin: 8px;
      padding: 0px !important;
    }

    .MuiDialogContent-root {
      padding: 8px;
    }
  }
`

export const ModalStyleOverride = createGlobalStyle<{
  $formLoaded: boolean
  $mvhColors?: MvhColorsType | null
}>`${cssModalStyleOverride}`

// the globalStyle above doesn't end up in the storyshots, so let's put this in a styled div in unit test mode
// so that we will capture the color/font CSS in storyshots, even if the behavior doesn't "truly" work in the unit test
export const ModalStyleOverrideUnitTest = styled.div<{
  $formLoaded: boolean
  $mvhColors?: MvhColorsType | null
}>`
  ${cssModalStyleOverride}
`
